import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { H3, H5 } from "../../../AbstractElements";
import { COUNTRIES } from "../../../libs/countries";

const CountrySelectPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSelect = (code) => {
    const target = code
      ? `${process.env.PUBLIC_URL}/${code}/pages/home`
      : `${process.env.PUBLIC_URL}/pages/home`;
    navigate(target);
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col sm="12" md="10" className="offset-md-1">
            <Row style={{ marginTop: 30 }}>
              <Col sm="12">
                <Card className="text-center">
                  <CardHeader className="p-3 border-0 rounded-pill">
                    <H3>{t("Select your country")}</H3>
                  </CardHeader>
                </Card>
              </Col>
            </Row>
            <Row style={{ marginTop: 30, marginBottom: 50 }}>
              {COUNTRIES.map((country) => (
                <Col
                  key={country.code || "default"}
                  sm="6"
                  md="4"
                  lg="3"
                  className="mb-3"
                >
                  <Card
                    onClick={() => handleSelect(country.code)}
                    style={{
                      cursor: "pointer",
                      boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
                    }}
                  >
                    <CardBody className="text-center p-4">
                      <i
                        className={`flag-icon flag-icon-${country.flag}`}
                        style={{ fontSize: "4rem", marginBottom: 16 }}
                      />
                      <H5 className="m-0">{country.label}</H5>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CountrySelectPage;
